import { render, staticRenderFns } from "./TwDashBoardProcess.vue?vue&type=template&id=f9d33256&scoped=true&"
import script from "./TwDashBoardProcess.vue?vue&type=script&lang=js&"
export * from "./TwDashBoardProcess.vue?vue&type=script&lang=js&"
import style0 from "./TwDashBoardProcess.vue?vue&type=style&index=0&id=f9d33256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d33256",
  null
  
)

export default component.exports